/**
 * 语言路由 Hook
 * 提供带语言前缀的路由导航功能
 */

import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { addLanguagePrefix, getLanguageFromPath } from '../utils/languageRoute';

/**
 * 使用带语言前缀的导航
 * 返回一个导航函数，自动添加当前语言前缀
 */
export const useLanguageNavigate = () => {
  const history = useHistory();
  const location = useLocation();
  const { i18n } = useTranslation();

  /**
   * 导航到指定路径，自动添加当前语言前缀
   * @param path - 目标路径（不带语言前缀），如 "/home"
   */
  const navigate = (path: string) => {
    const currentLanguage = getLanguageFromPath(location.pathname) || i18n.language.split('-')[0] || 'en';
    const fullPath = addLanguagePrefix(path, currentLanguage);
    history.push(fullPath);
  };

  return navigate;
};

/**
 * 获取带当前语言前缀的路径
 * @returns 一个函数，接收路径并返回带语言前缀的完整路径
 */
export const useLanguagePath = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  /**
   * 为路径添加当前语言前缀
   * @param path - 原始路径，如 "/home"
   * @returns 带语言前缀的路径，如 "/en/home"
   */
  const getPath = (path: string): string => {
    const currentLanguage = getLanguageFromPath(location.pathname) || i18n.language.split('-')[0] || 'en';
    return addLanguagePrefix(path, currentLanguage);
  };

  return getPath;
};
